import { RView1jxdnn5qf89cm as RView } from '../RView.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_instance15pczmasjuxgh as Companion_instance } from './ContainingView.commonHtml.mjs';
import { nativeSwap3qcor1bahhtzn as nativeSwap } from './SwapView.commonHtml.js.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SwapViewClass;
function SwapView() {
  if (SwapViewClass === VOID) {
    class $ extends RView() {
      constructor(context) {
        super(context);
        this.vb5_1.zb3_1 = 'div';
        this.vb5_1.jb4_1.v('kiteui-stack');
        // Inline function 'com.lightningkite.kiteui.views.overflowX' call
        this.vb5_1.db4_1.hb7_1.overflowX = 'hidden';
        // Inline function 'com.lightningkite.kiteui.views.overflowY' call
        this.vb5_1.db4_1.hb7_1.overflowY = 'hidden';
        this.sci_1 = null;
      }
      wb9(index, view) {
        super.wb9(index, view);
        Companion_instance.nbg(this, index, view);
      }
      tci(transition, createNewView) {
        nativeSwap(this, transition, createNewView);
      }
    }
    initMetadataForClass($, 'SwapView');
    SwapViewClass = $;
  }
  return SwapViewClass;
}
//region block: exports
export {
  SwapView as SwapView1526g6cz7z56r,
};
//endregion

//# sourceMappingURL=SwapView.commonHtml.mjs.map
